import { render, staticRenderFns } from "./api_usage_dashboard.vue?vue&type=template&id=5bc5491a&"
import script from "./api_usage_dashboard.vue?vue&type=script&lang=js&"
export * from "./api_usage_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports